import React, { useEffect } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";

// Helper
import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from "./Footer";

const RedesSociales = () => {
  const history = useHistory();
  let datos = localStorage.getItem("dataUser");

  if (!datos) {
    history.push("/");
  }

  let cred = JSON.parse(datos);
  SetBitacora.set(cred.carnet, 'Redes_sociales', cred.token);
  useEffect(() => {
    loadMenu();
  }, []);

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={cred.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={cred.carnet}
            nombre={cred.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Redes sociales</h2>
        <p className="text-muted mb-4">Sigue a la ESEN en sus canales oficiales.</p>

        <div className="card">
          <div className="list-group list-group-flush">
            {[
              { nombre: "Instagram", icono: "fa-instagram", url: "https://www.instagram.com/esenelsalvador/" },
              { nombre: "Facebook", icono: "fa-facebook-official", url: "https://www.facebook.com/ESENELSALVADOR" },
              { nombre: "LinkedIn", icono: "fa-linkedin-square", url: "https://www.linkedin.com/school/esen/" },
              { nombre: "Twitter", icono: "fa-twitter-square", url: "https://twitter.com/esenelsalvador" },
              { nombre: "YouTube", icono: "fa-youtube-play", url: "https://www.youtube.com/channel/UCYYmOUkD3Z0RiWNvF5TC_sw" },
            ].map((red) => (
              <a
                key={red.nombre}
                href={red.url}
                className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="d-flex align-items-center">
                  <i className={`fa ${red.icono} fa-lg text-primary mr-3`} aria-hidden="true"></i>
                  <span className="font-weight-bold">{red.nombre}</span>
                </span>
                <i className="fa fa-external-link text-muted" aria-hidden="true"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedesSociales;
